export default __webpack_public_path__ + "media/images/theme/wordmark_light-6e7bb3f20d16a4470650240eba80969c.png";